<template>
  <div>
    <title>快递打印记录详情</title>
     <section class="orderSect">
      <!--S 检索-->      
      <el-form :inline="true" :model="printFormInline">
        <el-form-item label="订单号/快递单号" class="codeSerIpt">
          <el-input v-model="printFormInline.expressno" placeholder="请输入订单号/快递单号" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getPrintRecordDetails">查询</el-button>
           <el-button type="primary" plain @click="$router.back(-1)">返回</el-button>
        </el-form-item>
      </el-form>
      <!--E 检索-->

      <!--S 快递打印列表-->
      <div class="allOrderTab">
        <el-table v-loading="loading" :data="printRecordData" ref="expressTable" class="orderTable comTable" border :maxHeight="tableHeight" >     
            <el-table-column type="index" fixed label="序号"></el-table-column>
            <el-table-column label="快递单号" fixed prop="expno" sortable min-width="200">
              <template slot-scope="scope">
                <p>{{scope.row.expno}}</p>
                <small>{{expecttitle}}：{{ dateTime(scope.row.recvdate, 2)}}</small>
              </template>
            </el-table-column>
            <el-table-column label="订单号" prop="orderno" sortable  min-width="230">
              <template slot-scope="scope">
                <small>{{scope.row.orderno}}</small>
              </template>
            </el-table-column>
            <el-table-column label="快递内容" prop="expcontent" sortable width="450">
              <template slot-scope="scope">
                <p class="textFl" :title="scope.row.expcontent">{{scope.row.expcontent}}</p>
              </template>
            </el-table-column>
            <el-table-column label="收货信息" prop="fulladdr" sortable width="450">
              <template slot-scope="scope">
                <div class="shouMsg">
                  <em v-if="scope.row.receivername">{{scope.row.receivername}}</em>
                  <em v-if="scope.row.receivertel">{{scope.row.receivertel}}</em>
                </div>              
                <p v-if="scope.row.fulladdr" class="greyColor textFl" :title="scope.row.fulladdr">{{scope.row.fulladdr}}</p>
              </template>
            </el-table-column>
            <template slot="empty">
              <div class="noData"><span>暂无数据</span></div>
            </template>
        </el-table>
      </div>
      <!--S 快递打印列表-->
      <Page :pageTotal="pagebean.totalnum" :currentPage="pagebean.currentpage" @nowPageParam="setPageparam"></Page>
    </section>
  </div>
</template>
<script>
import { Message, MessageBox } from "element-ui";
import api from '../../apis/api';
export default {
  name: 'PrintRecordDetail',
  data () {
    return {
      expecttitle: '',
      printFormInline:{
        orderno: "", //订单号
        expressno:"",//快递单号
      },
      printRecordData:[],//打印列表数据
      tableHeight: window.innerHeight * 0.8, //表格动态高度
      expgenbatchno: '',//打印批次编号
      pagebean: {
        pagesize: 30,
        currentpage: 1
      },//分页
      loading: true,//加载
    }
  },
  components: {
    Page: resolve => require(["@/components/common/Page.vue"], resolve),
  },
  methods: {
    //动态获取表格高度
    getHeight() {
      let tbHeight = this.$refs.expressTable.$el.offsetTop; //顶部检索条件占据的高度
      this.tableHeight = window.innerHeight - tbHeight - 130;
      //console.log('表格距离顶部高度',tbHeight,'可视区高度',window.innerHeight)
    },

    //设置分页数据
    setPageparam(nowPageSize, nowCurrentPage) {
      if(nowPageSize) {
        this.pagebean.pagesize = nowPageSize
      }
      if(nowCurrentPage) {
        this.pagebean.currentpage = nowCurrentPage
      }
      this.getPrintRecordDetails()
    },

    //获取列表页
    getPrintRecordDetails() {
      this.loading = true
      let params = {
        pbatchcode: this.expgenbatchno,
        orderno: this.printFormInline.expressno, //订单号
        pageparam: this.pagebean
      }
      api.GET_EXPPRINTRECORDDETAIL(params).then(res => {
        if(res.data.status == '200') {
          this.printRecordData = res.data.data
          this.pagebean = res.data.pagebean
        } else {
          this.printRecordData = []
        }
        this.loading = false
      })
    }
  },
  created() {
    //页面浏览器视窗变化绑定resize事件
    window.addEventListener("resize", this.getHeight);
  },
  mounted() {
    //在dom渲染之后
    setTimeout(() => {
      this.expgenbatchno = this.$route.params.expgenbatchno
      this.getHeight();
      this.getPrintRecordDetails()
      this.expecttitle = localStorage.getItem("pubordprintinfo") ? JSON.parse(localStorage.getItem("pubordprintinfo")).expecttitle : ''
    }, 200);
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight); //销毁监听浏览器视窗变化
  }
}
</script>

<style scoped>
@import "Css/Style.css";
</style>



// WEBPACK FOOTER //
// src/views/DeliveryFolder/PrintRecordDetail.vue